import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const DeleteFlow = async (domain: string, flowId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows/${flowId}`,
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}